import { NumberInput, NumberInputProps } from '../ui/number-input'

import FloatingLabel from './FloatingLabel'

interface Props extends NumberInputProps {
  label: string
  labelClassName?: string
}

const LabeledInputNumber = ({ label, labelClassName, ...inputNumberProps }: Props) => {
  return (
    <FloatingLabel label={label} className={labelClassName}>
      <NumberInput {...inputNumberProps} locale="de-DE" useGrouping={false} />
    </FloatingLabel>
  )
}

export default LabeledInputNumber
